import { createSlice } from "@reduxjs/toolkit";

export const productsSlice = createSlice({
    name: 'products',
    initialState: [],
    reducers: {
        addProduct: (state, action) => {
            state.push(action.payload)
        },
        setProducts: (state, action) =>{
            return action.payload
        },
        clearProducts: (state, action)=>{
            return []
        }
    }
})

export const { addProduct, setProducts, clearProducts } = productsSlice.actions

export default productsSlice.reducer